export function ellipseAddress(address = '', width= 5) {
  return `${address.slice(0, width+1)}...${address.slice(-width+1)}`
}

export function padLeft(n: string, width: number, z?: string) {
  z = z || '0'
  n = n + ''
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n
}
